import React from "react";

function TextList({color, number, text}){
    return(
        <div className='list'>
            <div className={`number-section ${color}`}>
                <p>{number}</p>
            </div>
            <span><div dangerouslySetInnerHTML={{__html: text}}/></span>
        </div>
    );
}

export default function AlurPeminjamanTextProduktif({type}){
    switch (type) {
        default:
            return(
                <div className='alur-peminjaman-text'>
                    <TextList color='green' 
                        number={1} text='Calon Penerima Dana mengajukan permohonan pinjaman secara online melalui website atau aplikasi Danai.id'/>
                    <TextList color='grey' 
                        number={2} text='Danai.id akan menghubungi calon Penerima Dana melalui tim sales/ marketing'/>
                    <TextList color='blue' 
                        number={3} text='Calon Penerima Dana mempersiapkan dokumen yang diperlukan'/>
                    <TextList color='green' 
                        number={4} text='Setelah dokumentasi lengkap, Danai.id memproses pengajuan pinjaman sesuai dengan prosedur yang berlaku'/>
                    <TextList color='grey' 
                        number={5} text=' Jika pengajuan pinjaman disetujui, Danai.id akan mengirimkan penawaran pinjaman kepada calon Penerima Dana'/>
                    <TextList color='blue' 
                        number={6} text='Sesudah calon Penerima Dana memberikan persetujuan, pengajuan pinjaman akan masuk ke <em>marketplace</em> Danai.id'/>
                    <TextList color='green' 
                        number={7} text='Pemberi Dana akan melakukan pendanaan dengan menentukan jumlah pinjaman sesuai dengan preferensi'/>
                    <TextList color='grey' 
                        number={8} text='Setelah dana terpenuhi, Danai.id akan mengirimkan dana ke rekening Penerima Dana yang telah terdaftar setelah dikurangi biaya-biaya'/>
                </div>
            );
            break;
    }
}